import { Helmet } from "react-helmet"
import { BaseLayoutType } from "../types"
import { Authorized } from "../authentication/Authorized"

export default function BaseLayout({ title, image, children, permissions }: BaseLayoutType) {
    return (
        <section className="h-screen w-full flex flex-col items-center justify-start">
            <Helmet>
                <title>Hausmanager | {title}</title>
                <link rel="icon" href={image} />
            </Helmet>
            <Authorized anyOf={permissions}>{children}</Authorized>
        </section>
    )
}
